import { useCallback } from "react";
import { useInputValue } from "./useInputValue.js";
import { useNativeInput } from "./useNativeInput.js";
const useTextBasedInput = (props, forwardedRef) => {
  const { state, onChange } = useInputValue({
    ...props,
    emptyValue: "",
    extractValue: useCallback((input) => input.value, [])
  });
  const inputProps = useNativeInput(props, forwardedRef);
  return {
    ...inputProps,
    onChange,
    value: state ?? ""
  };
};
export {
  useTextBasedInput
};
//# sourceMappingURL=useTextBasedInput.js.map
